/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Apr 11 2024
 **/

import { Column } from "@/frameworks/designStuff/components";
import { hoverScrollCss } from "@/frameworks/designStuff/utils";

import { useTusUploadTargetRenderer } from "@/frameworks/core/hooks";
import FileUploadItem from "./FileUploadItem";

export default function FileUploadList() {
	const tusUploadState = useTusUploadTargetRenderer("FILEBOX");

	// filter out error state
	const filteredObject = Object.fromEntries(
		Object.entries(tusUploadState).filter((entry) => entry[1].status !== "error")
	);

	return (
		<Column.ul css={[{ maxHeight: 204, width: "100%" }, hoverScrollCss()]} gap={16}>
			{Object.keys(filteredObject).map((tusID) => {
				const currentFile = filteredObject[tusID];
				return <FileUploadItem key={tusID} {...currentFile} tusID={tusID} />;
			})}
		</Column.ul>
	);
}
